import { useDispatch, useSelector } from 'react-redux';
import { IconHamburger } from 'containers/menuV2/icons/IconHamburger';
import { useMemo, useState } from 'react';
import { useLocation } from 'react-router-dom';
import './styles.scss';
import { useHistory } from 'react-router-dom/cjs/react-router-dom.min';
import { updateWorldParams } from 'store/actions';
import {
  OVERVIEW_SCENE_ID,
  OVERVIEW_GROUP_ID,
  APARTMENT_SCENE_ID,
  APARTMENT_GROUP_ID,
} from 'consts/building';
import { ROUTE_MAP } from 'consts/url';

const logoPath = process.env.PUBLIC_URL + '/assets/images/logo/white-logo-newstar.webp';

const MenuTop = () => {
  const [openMenuMobile, setOpenMenuMobile] = useState(false);
  const { menu } = useSelector((state) => state.json);

  const history = useHistory();
  const dispatch = useDispatch();

  const { pathname } = useLocation();

  const newPathName = pathname.split('/')[1] || '';

  const keyArr = ['vi-tri', 'tien-ich', 'mat-bang-tang', 'can-ho-mau'];

  const menuOverwride = useMemo(
    () => [
      {
        id: ROUTE_MAP.overview.id,
        onClick: () => {
          dispatch(
            updateWorldParams({
              groupId: OVERVIEW_GROUP_ID,
              sceneId: OVERVIEW_SCENE_ID,
            })
          );
          history.push(`/${ROUTE_MAP.overview.id}`);
        },
      },
      {
        id: 'vi-tri',
        onClick: () => {
          history.push('/vi-tri');
        },
      },
      {
        id: ROUTE_MAP['can-ho-mau'].id,
        onClick: () => {
          dispatch(
            updateWorldParams({
              groupId: APARTMENT_GROUP_ID,
              sceneId: APARTMENT_SCENE_ID,
            })
          );
          history.push(`/${ROUTE_MAP['can-ho-mau'].id}`);
        },
      },
    ],
    [dispatch, history]
  );

  const mapMenuToPath = useMemo(() => {
    return menu.map((item, index) => ({
      ...item,
      ...menuOverwride[index],
    }));
  }, [menu, menuOverwride]);

  return (
    <>
      <nav className="menu-top">
        <header className="menu-header">
          <div className="menu-logo">
            <img src={logoPath} alt="Logo" />
          </div>
          <div className="nav-desktop">
            {mapMenuToPath.map((item) => {
              let isActive = false;

              if (keyArr.includes(newPathName)) {
                isActive = newPathName === item.id;
              } else {
                isActive = item.id === 'tong-quan';
              }

              return (
                <button
                  key={item.id}
                  onClick={() => {
                    item.onClick();
                    setOpenMenuMobile(false);
                  }}
                  className={`menu-item ${isActive ? 'active' : ''}`}
                >
                  <span className="menu-item-label">{item.name}</span>
                </button>
              );
            })}
          </div>
        </header>

        <button
          className="nav-mobile-btn"
          onClick={() => setOpenMenuMobile(!openMenuMobile)}
        >
          <span className="btn-label">{openMenuMobile ? 'Close' : 'Menu'}</span>
          <IconHamburger isActive={openMenuMobile} />
        </button>
      </nav>

      <div className={`nav-mobile-menu ${openMenuMobile ? 'open' : ''}`}>
        {mapMenuToPath.map((item) => {
          let isActive = false;

          if (keyArr.includes(newPathName)) {
            isActive = newPathName === item.id;
          } else {
            isActive = item.id === 'tong-quan';
          }

          return (
            <button
              key={item.id}
              onClick={() => {
                item.onClick();
                setOpenMenuMobile(false);
              }}
              className={`menu-item ${isActive ? 'active' : ''}`}
            >
              <span className="menu-item-label">{item.name}</span>
            </button>
          );
        })}
      </div>
    </>
  );
};

export default MenuTop;
